export const GOVERNING_LAWS = [
  { id: 'English', displayValue: 'English' },
  { id: 'German', displayValue: 'German' },
  { id: 'New_York', displayValue: 'New York' },
];
